export default __webpack_public_path__ + "static/media/11.9be0cec9.png";